import type { AnyAction } from '@reduxjs/toolkit';
import type { Reducer } from 'react';

import type { CacheInstanceKey } from '../middlewares/cache-lift';

// state.tocCache 用于在 tocCacheMiddleware 中索引 tocCache 实例
export const cacheReducer: Reducer<CacheInstanceKey | undefined, AnyAction> = (state = {}) => {
  return state;
};
